import { StaticInterface } from '../../../helpers/static-interface';

export interface ITpxFeatureUtils {
  animate(): void;
}

export interface IStaticTpxFeatureUtils {
  new (...args: any[]): ITpxFeatureUtils;
  init(): void;
}

/**
 * Feature functionality
 * @class
 */
export default class TpxFeatureUtils implements StaticInterface<IStaticTpxFeatureUtils, typeof TpxFeatureUtils> {
  #element: HTMLElement;
  #observer: IntersectionObserver;

  /**
   * @constructor
   * @param {HTMLElement} element The navigation bar root element
   */
  constructor(element: HTMLElement) {
    this.#element = element;
    this.#element?.classList.add('o-feature--ready');
    
    this.#observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.animate();
          this.#observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: .4,
    });

    this.#observer.observe(this.#element);
  }

  animate() {
    this.#element?.classList.remove('o-feature--ready');
    this.#element?.classList.add('o-feature--animate');
  }

  /**
   * Creates new instances of TpxFeatureUtils for each `.o-feature` element
   */
  static init() {
    const features: Element[] = [...document.getElementsByClassName('o-feature')];
    features.forEach(feature => {
      new TpxFeatureUtils(feature as HTMLElement);
    });
  }
}